import { createFileRoute } from "@tanstack/react-router";
import { GiftsPage } from "../components/gifts/GiftsPage";

export const Route = createFileRoute("/_auth/_messaging/gifts")({
  staticData: { titleKey: "nav.messaging", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  component: GiftsPage,
});
